// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2J7nb","unreadBadge":"styles_unreadBadge__1TecV","modalContent":"styles_modalContent__1YEsi","modal":"styles_modal__2TDWy"};